export const useCurrencyRates = {
  computed: {
    currencyRates() {
      return this.$store.state.Auth.currencyRates;
    },
  },
  methods: {
    convertCurrency(from, to, value) {
      const convertObject = this.currencyRates?.find((el) => {
        return el.from === from && el.to === to;
      });

      const course = convertObject?.value ?? 1;

      return value * course;
    },
  },
};
